import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

const API_BASE = '/planner-api';

export const fetchLocations = createAsyncThunk('locations/fetch', async (token) => {
  const res = await fetch(`${API_BASE}/locations`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) throw new Error('Failed to fetch locations');
  return res.json();
});

export const createLocation = createAsyncThunk('locations/create', async ({ token, location }) => {
  const res = await fetch(`${API_BASE}/locations`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
    body: JSON.stringify(location),
  });
  if (!res.ok) throw new Error('Failed to create location');
  return res.json();
});

export const updateLocation = createAsyncThunk('locations/update', async ({ token, id, data }) => {
  const res = await fetch(`${API_BASE}/locations/${id}`, {
    method: 'PUT',
    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
  if (!res.ok) throw new Error('Failed to update location');
  return res.json();
});

export const deleteLocation = createAsyncThunk('locations/delete', async ({ token, id }) => {
  const res = await fetch(`${API_BASE}/locations/${id}`, {
    method: 'DELETE',
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) throw new Error('Failed to delete location');
  return id;
});

const locationsSlice = createSlice({
  name: 'locations',
  initialState: {
    list: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchLocations.pending, (state) => { state.loading = true; })
      .addCase(fetchLocations.fulfilled, (state, action) => {
        state.list = action.payload;
        state.loading = false;
      })
      .addCase(fetchLocations.rejected, (state) => { state.loading = false; })
      .addCase(createLocation.fulfilled, (state, action) => {
        state.list.unshift(action.payload);
      })
      .addCase(updateLocation.fulfilled, (state, action) => {
        const idx = state.list.findIndex(l => l.id === action.payload.id);
        if (idx >= 0) state.list[idx] = action.payload;
      })
      .addCase(deleteLocation.fulfilled, (state, action) => {
        state.list = state.list.filter(l => l.id !== action.payload);
      });
  },
});

export const selectLocations = (state) => state.locations.list;
export const selectLocationsLoading = (state) => state.locations.loading;
export const selectLocationsByType = (type) => (state) =>
  state.locations.list.filter(l => l.type === type);
export default locationsSlice.reducer;
